/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <transition name="fadeIn" @after-enter="toggleContent(true)" @before-leave="toggleContent(false)">
    <div class="wrapp-rightbar" v-show="rightActiveComponent.component" ref="wrappRightBar">
      <div class="rightbar-overlay" @click="closeRightBar"></div>
      <div class="wrapp-rightbar__content" :class="dynamicClass">
        <div class="wrapp-rightbar__content__header">
          <button class="btn btn-icon btn-icon-small btn-icon-border-black btn-rounded" v-show="rightNavHistory.length > 1 || showGoBack" @click.prevent="goBackHistory">
            <svg class="o-icon"><use xlink:href="#arrow-left-short"></use></svg>
          </button>
          <button class="btn btn-icon btn-icon-small btn-icon-border-black btn-rounded" @click.prevent="closeRightBar">
            <svg class="o-icon"><use xlink:href="#back"></use></svg>
          </button>
        </div>
        <no-ssr>
          <overlay-scrollbars class="wrapp-rightbar__content__body" :options="{ overflowBehavior: {x: 'hidden', y: 'scroll'} }" ref="rightNavScrollbar">
            <div class="wrapp-rightbar__content__body__dynamic">
              <component :is="rightActiveComponent.component" v-bind="rightActiveComponent.props"></component>
            </div>
          </overlay-scrollbars>
        </no-ssr>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'RightNavigation',
  props: {
    showGoBack: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    rightNavHistory () {
      return this.$store.state.ui.rightNavHistory
    },
    rightActiveComponent () {
      // if (this.$refs.rightNavScrollbar) {
      //   const osInstance = this.$refs.rightNavScrollbar.osInstance()
      //   osInstance.scrollStop().scroll(0)
      // }
      return this.$store.getters['ui/getRightActiveComponent']
    },
    dynamicClass () {
      let classObj = {}
      let rightActiveComponent = this.$store.state.ui.rightActiveComponent
      if (rightActiveComponent && rightActiveComponent.component && rightActiveComponent.component.name) {
        classObj = {
          [`component-active-${rightActiveComponent.component.name.toLowerCase()}`]: true
        }
      }
      return classObj
    }
  },
  methods: {
    closeRightBar () {
      this.$store.commit('ui/setRightActiveComponent', {})
    },
    goBackHistory () {
      this.$store.dispatch('ui/loadRightActiveComponent', { isBack: true })
    },
    toggleContent (toggle) {
      $('.wrapp-rightbar').toggleClass('show-content', toggle)
    }
  }
}
</script>
